import validate from "D:/oneway/machine-web/node_modules/.pnpm/nuxt@3.2.2_stylus@0.59.0/node_modules/nuxt/dist/pages/runtime/validate.mjs";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {}